import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface StatCardProps {
  label: string;
  value: string | number;
  subtitle?: string;
  subtitleColor?: 'green' | 'yellow' | 'red' | 'blue' | 'muted';
}

const subtitleColors = {
  green: 'text-green-600 dark:text-green-400',
  yellow: 'text-yellow-600 dark:text-yellow-400',
  red: 'text-red-600 dark:text-red-400',
  blue: 'text-indigo-600 dark:text-indigo-400',
  muted: 'text-muted-foreground'
} as const;

export function StatCard({ label, value, subtitle, subtitleColor = 'muted' }: StatCardProps) {
  return (
    <Card className="overflow-hidden">
      <CardContent className="border-l-4 border-primary p-4">
        <p className="text-xs font-medium uppercase text-muted-foreground">{label}</p>
        <p className="mt-1 text-2xl font-bold">{value}</p>
        {subtitle && (
          <p className={cn('mt-1 text-xs', subtitleColors[subtitleColor])}>{subtitle}</p>
        )}
      </CardContent>
    </Card>
  );
}
